exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hover-2-wrapper[data-v-3a02e532]{width:210px;padding-bottom:10px}", ""]);

// exports
